// ─── Projects Registry ─────────────────────────────────────────────────────────
// To add a new project:
// 1. Add an entry below with your project details
// 2. Push - it appears on build.shashankupadhyaya.com automatically

export const projects = [];
